export default "__VITE_ASSET__Cge5hCTq__"